import React from 'react'
import ReactDOM from 'react-dom'
//import './index.css'
// import App from './App'
import 'core-js/fn/array'
import 'core-js/fn/set'
import 'core-js/fn/map'
import 'core-js/fn/object/values'
import registerServiceWorker from './registerServiceWorker'
import { Provider } from 'react-redux'
import { createBrowserHistory } from 'history'
import { applyMiddleware, compose, createStore } from 'redux'
import { connectRouter, routerMiddleware, ConnectedRouter } from 'connected-react-router'
import { MuiThemeProvider, CssBaseline } from '@material-ui/core'
import { createTheme } from '@michelin/acid-components'
import rootReducer from './reducers'
import routes from './routes'
import thunk from 'redux-thunk'
import promiseMiddleware from 'redux-promise-middleware'
import IntlProvider from './IntlProvider'
import Startup from './Startup'

require('./utilities')

const history = createBrowserHistory()

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

const store = createStore(
	connectRouter(history)(rootReducer),
	{}, // <- Preloaded state. The reducers define the default state.
	composeEnhancers(
		applyMiddleware(
			routerMiddleware(history),
			thunk,
			promiseMiddleware()
		),
	),
)

const theme = createTheme()

ReactDOM.render(
	<MuiThemeProvider theme={theme}>
		<CssBaseline />
		
		<Provider store={store} >
			<Startup>
				<IntlProvider>
					<ConnectedRouter history={history}>
							{routes}
					</ConnectedRouter>
				</IntlProvider>
			</Startup>
		</Provider>
	</MuiThemeProvider>,
	document.getElementById('root')
)

registerServiceWorker()


// WEBPACK FOOTER //
// ./src/index.js